import { Button, Container, Eyebrow, Lead, Section, SectionTitle } from '@vcn/ui'
import { useContent } from "../content";

export function FinalCta() {
  const { finalCta } = useContent();

  return (
    <Section id="kontakt" className="scroll-mt-20 text-center">
      <Container>
        <Eyebrow>{finalCta.eyebrow}</Eyebrow>
        <SectionTitle className="mt-4">{finalCta.title}</SectionTitle>
        <Lead className="mx-auto mt-6 max-w-2xl">{finalCta.body}</Lead>

        <div className="mx-auto mt-10 flex w-full max-w-xs flex-col gap-3">
          {finalCta.ctas.map((cta) => (
            <Button key={cta.href} href={cta.href} variant={cta.variant}>
              {cta.label}
            </Button>
          ))}
        </div>
      </Container>
    </Section>
  )
}
